import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';

const Profile = ({ user }) => {
  return (
    <Box sx={{ p: 3, textAlign: 'center' }}>
      <Avatar
        src={`https://ui-avatars.com/api/?name=${encodeURIComponent(`${user.name} ${user.last_name}`)}&background=303B4B&color=fff`}
        alt="آواتار"
        sx={{ width: 100, height: 100, mx: 'auto', mb: 3 }}
      />

      <Typography variant="h6" py={3} gutterBottom>
        مشخصات کاربری
      </Typography>

      <TextField
        label="نام و نام خانوادگی"
        value={`${user.name} ${user.last_name}`}
        fullWidth
        InputProps={{ readOnly: true }}
        sx={{ mb: 2, backgroundColor: '#303B4B', borderRadius: '8px' }}
      />

      <TextField
        label="نام کاربری"
        value={user.username}
        fullWidth
        InputProps={{ readOnly: true }}
        sx={{ mb: 2, backgroundColor: '#303B4B', borderRadius: '8px' }}
      />

      <TextField
        label="ایمیل"
        value={user.email || 'ثبت نشده'}
        fullWidth
        InputProps={{ readOnly: true }}
        sx={{ mb: 2, backgroundColor: '#303B4B', borderRadius: '8px' }}
      />

      <TextField
        label="شماره موبایل"
        value={user.phone_number || 'ثبت نشده'}
        fullWidth
        InputProps={{ readOnly: true }}
        sx={{ mb: 2, backgroundColor: '#303B4B', borderRadius: '8px' }}
      />

      <Box sx={{ mt: 'auto', pt: 5 }}>
        <Button
          fullWidth
          variant="outlined"
          color="error"
          onClick={() => {
            fetch('/db/logout.php', { method: 'POST', credentials: 'include' })
              .then(() => window.location.replace('/auth/login'));
          }}
          sx={{ fontWeight: 'bold' }}
        >
          خروج از حساب
        </Button>
      </Box>
    </Box>
  );
};

export default Profile;